import axios from "axios";
import { API_DOMAIN } from "../constants";

// Generic uzd_misc mode, following the same get_misc_mode/save_misc_mode
// convention used elsewhere (wati_operators_online_status,
// template_approval_feature_toggle, etc.) — see SettingsModal.js.
export const FEATURE_VISIBILITY_MODE = "qv4_feature_visibility";

// Add a { key, label } entry here for every button/section that should be
// admin-configurable; QuerysetV4.js gates its JSX on canSeeFeature(key) and
// SettingsModal.js's Feature Visibility panel lists exactly these.
export const FEATURE_KEYS = [
  { key: "send_bulk_wati", label: "Send Bulk WATI Messages" },
  { key: "create_pdf", label: "Create & Send Queries PDF" },
  { key: "vehicle_brands", label: "Vehicle Brands & Models" },
  { key: "view_toggle", label: "Kanban / Table View Toggle" },
];

export async function fetchFeatureVisibility() {
  try {
    const res = await axios.post(API_DOMAIN + "/whatsapp/get_misc_mode", { mode: FEATURE_VISIBILITY_MODE });
    return res.data.success ? (res.data.data || {}) : {};
  } catch {
    return {};
  }
}

export async function saveFeatureVisibility(config) {
  const res = await axios.post(API_DOMAIN + "/whatsapp/save_misc_mode", { mode: FEATURE_VISIBILITY_MODE, moredetails: config });
  return !!res.data.success;
}

// Fails closed: a feature not yet configured (or the whole config not
// loaded yet) is hidden for everyone, admins included — being an admin no
// longer bypasses this. Safe to fail closed since the Settings button
// itself is never gated by this system, so an admin can always reach the
// panel that grants access, even if every feature is currently hidden
// from them too.
export function canSeeFeature(config, key, authState, hasPermission = false) {
  const entry = config?.[key];
  if (!entry) return false;
  if (entry.access === "all") return true;
  // Backward-compatible interpretation of stored legacy values: "admins"
  // now means holders of the feature's explicit permission, never Users.admin.
  if (entry.access === "admins") return hasPermission;
  if (entry.access === "users") return (entry.userIds || []).includes(authState?.id);
  return false; // unknown access value
}
